
<app-header></app-header>
<div class="page-maintenance">
    <div class="maintenance-cnt">
        <div class="spacer-xl"></div>
        <h1 class="webapp-title" style="color: var(--light-gray)">🛠️ Mantenimiento en curso 🚧</h1>
        <div class="main-title"></div>
        
        <p style="color: #FFF;">Gracias por tu paciencia. Volvé más tarde, pronto estaremos de vuelta.</p>
        <h2 class="overlay-title">Estamos trabajando para brindarte una mejor experiencia.</h2>

        <div class="spacer-xl"></div>
        <div class="spacer-xl"></div>
        <div class="flex-col">
            <!-- <button (click)="goToCalendly()" class="button button-fill button-round w75" style="background-color:#3A78C9;color: #FFF">
                Reservar videollamada GRATIS
            </button> -->

            <button (click)="goToWebsite()" class="button button-fill button-round w75">
                Página web
            </button>
        </div>
    </div>
</div>